import { Mapping } from '@teetsh/app/src/containers/Eleves/Import/File/csv';
import { getFieldFromRow } from '@teetsh/app/src/containers/Eleves/Import/File/utils/getFieldFromRow';
import { ScholarSystems } from '@teetsh/app/src/containers/scholarSystem';

function guessClassroomDegree(clRows: object[], niveauMapping?: Mapping) {
  const degreeValues = (clRows || [])
    .map(r => getFieldFromRow(r, niveauMapping))
    .filter(d => !!d);
  for (const degreeValue of degreeValues) {
    if (
      ScholarSystems.FR.niveaux
        .map(d => d.niveau.toLocaleLowerCase())
        .includes(degreeValue.toLocaleLowerCase())
    ) {
      return degreeValue;
    }
  }
  return undefined;
}

export { guessClassroomDegree };
